module.exports = __webpack_public_path__ + "static/media/ic_debit_note.95a88c54.svg";